<template>
    <div class="agree">
        <div class="go_back" @click="back"></div>
        <div class="content">
                <div class="passage">杭州寻匠之美网络科技有限公司（以下简称“本公司”）按照下列条款与条件提供信息和产品，<span class="point">您在本协议中亦可被称为“用户”，以下所述条款和条件将构成您与本公司，就您使用提供的内容所达成的全部协议（以下称“本协议”）。</span></div>

                <div class="title">说明</div>

                <div class="passage">本公司向您提供包括但不限于下载、使用、充值、客户服务、资讯、论坛交流等服务（以下称“本服务”）。<span class="point">本公司针对本服务所制定的相关规定，包括但不限于本公司在平台平台下运营的任何一款平台所包含的平台规则、用户处罚条例，客服条例等，以及本公司就账号使用及管理、平台充值等服务制定的相关服务协议、规则。</span>本公司在此提示用户，请您在使用本服务前详细阅读本协议的所有内容，尤其是免除、限制本公司责任或者限制用户权利的条款（特别是粗体下划线标注的内容），<span class="point">如您对本协议有任何疑问，请向本公司（0571-85319056 ）进行咨询。</span>一旦您使用本服务，即表示您已阅读并完全同意接受本协议项下所述条款和条件的约束。如果您不同意本协议的任何条款，请您不要使用本服务。未成年人应经其监护人陪同阅读本服务协议并表示同意，方可接受本服务协议。监护人应加强对未成年人的监督和保护，因其未谨慎履行监护责任而损害未成年人利益或者本公司利益的，应由监护人承担责任。</div>

                <div class="title">权利声明</div>

                <div class="passage">1) 本公司及其关联公司（关联企业指与本公司存在直接或间接，股权或以协议安排等其他形式的控制与被控制关系，以及对公司运营具有重大影响关系的公司法人）享有并保留以下各项内容完整的、不可分割的所有权及/或知识产权：</div>

                <div class="passage">（1）平台相关的软件、技术、程序、代码、用户界面等；</div>

                <div class="passage">（2）本服务相关的商标、图形标记。</div>

                <div class="passage">2) 本公司提供的服务内容中所涉及的平台，文字、软件、声音、图片、动画、录像、图表等，均受相关知识产权法以及其他相关法律的保护。未经本公司或者其他相关权利人授权，用户不得复制、使用、修改、摘编、翻译、发行,第三方未经本公司及/或其相关权利人的书面许可，不得以任何方式擅自进行使用。</div>

                <div class="title">责任限制</div>   

                <div class="passage">1、本公司向用户提供的服务均是在依”现状”提供，本公司在此明确声明对本服务不作任何明示或暗示的保证，包括但不限于对服务的可适用性、准确性、及时性、可持续性等。</div>  

                <div class="passage">2、用户理解并同意自行承担使用本服务的风险，且用户在使用本服务时，应遵循中国法律的相关规定，由于用户行为所造成的任何损害和后果，本公司均不承担除法律有明确规定外的责任。</div>  

                <div class="passage">3) <span class="point">不论在何种情况下，本公司均不对由于网络连接故障、通讯线路、第三方网站、电脑硬件等任何原因给用户造成的任何损失承担除法律有明确规定外的责任。</span></div>  

                <div class="title">用户行为规范</div>

                <div class="passage">1) 用户在本网站注册时，不得使用虚假身份信息。用户应当妥善保存其账户信息和密码，由于用户泄密所导致的损失需由用户自行承担。如用户发现他人冒用或盗用其账户或密码，或其账户存在其他未经合法授权使用之情形，应立即以有效方式通知本公司。用户理解并同意本公司有权根据用户的通知、请求或依据判断，采取相应的行动或措施，包括但不限于冻结账户、限制账户功能等，本公司对采取上述行动所导致的损失不承担除法律有明确规定外的责任。</div>

                <div class="passage">2) 用户在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于：</div>
                <div class="passage"><span class="point">（1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；</span></div>

                <div class="passage">（2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；</div>

                <div class="passage">（3）恶意虚构事实、隐瞒真相以误导、欺骗他人；</div>

                <div class="passage">（4）发布、传送、传播广告信息及垃圾信息；</div>

                <div class="passage">（5）其他法律法规禁止的行为。</div>

                <div class="passage">3) 用户不得利用本服务进行任何有损本公司及其关联企业之权利、利益及商誉，或其他用户合法权利之行为。</div>
                <div class="passage"><span class="point">4) 用户不得基于本服务从事制作、使用、传播“私服”、“外挂”等侵害本公司合法权益的行为。如有违反，本公司将依据中国现行法律法规及本公司的相关规定予以处理。</span></div>


                <div class="passage">5) 虚拟财产转移服务外，用户不得通过任何方式直接或变相进行平台账号、平台币、平台道具等虚拟财产的转移。</div>

                <div class="passage">6) 用户不得从事作弊等损害平台公平性的行为。用户承诺接受本公司对其平台数据进行分析，当本公司发现其数据异常时，本公司可根据自己的独立判断认定其为作弊。</div>

                <div class="passage">7) 用户不得从事任何利用本公司平台系统漏洞进行有损其他用户、本公司或互联网安全的行为。</div>

                <div class="passage"><span class="point">8) 用户知悉并确认，本公司通过公告、邮件、短信、账户通知以及用户在账户中登记的即时通讯工具等方式，向用户发出关于本服务的通知、规则、提示等信息，均为有效通知。该等信息一经公布或发布，即视为已送达至用户。</span></div>

                <div class="title">广告信息和促销</div>

                <div class="passage">1) 用户同意接受本公司通过公告、邮件、短信、账户通知以及用户在账户中登记的即时通讯工具等方式发送的有关本服务，或本公司、本公司之关联企业或与本公司有合作关系的第三方相关的商品、服务促销或其他商业信息。</div>

                <div class="passage">2) 本公司在本服务中可能提供与其他互联网之网站站点或资源的链接，本公司对存在或源于此类网站站点或资源的任何内容、广告、产品或其他资料不予保证或负责；如该链接所载的内容或搜索引擎所提供之链接的内容侵犯用户权利，本公司声明与上述内容无关，且不承担除法律有明确规定外的责任。</div>

                <div class="date">日期：2019年7月2日</div>
            </div>    
            <a href="tel:0571-85319056"><div class="call">
                <div class="call_img"><img src="/static/images/service.png"></div>
                <div class="call_msg">还有其他疑问，请点击此处联系客服(9:00-18:00)</div>
            </div></a>
            <temp_top></temp_top>
    </div>
</template>
<script>
import  temp_top from './common.vue'
    export default {
        name: 'Agreement',
        data () {
             return {

             }
        },
        components:{
            "temp_top":temp_top,
        },
         created(){
              document.title = '隐私政策';
        } ,
        methods:{
            back(){
                 this.$router.go(-1);
            }
        }
    }
</script>
<style  scoped>
.agree{padding-top:26px;position: relative;padding-bottom:160px;}
.go_back{width:48px;height:48px;background:url("/static/images/team_go_back.png") no-repeat center center;background-size:100% 100%;margin:10px 16px 16px 10px;}
.content{width:698px;margin:0 auto;}
.passage{color:#9B9B9B;font-size:28px;line-height:52px;margin:6px 0;}
.title{font-size:32px;color:#000000;margin:60px 0 40px;font-weight:bold;}
.point{color:#333334;font-weight:bold;}
.date{font-size:28px;color:#9B9B9B;text-align:right;}
.call{position:absolute;left:0;bottom:0;width:100%;height:100px;line-height:100px;background:#F7F4E0;display:flex;justify-content: center;font-size:28px;color:#96865C;}
.call_img{width:44px;height:44px;margin-right:14px;}
.call_img img{width:100%;height:100%;margin-top:26px;}
</style>


// WEBPACK FOOTER //
// src/components/person/agreement.vue